import { render, staticRenderFns } from "./product-title.component.vue?vue&type=template&id=47ee018c&scoped=true&"
import script from "./product-title.component.vue?vue&type=script&lang=js&"
export * from "./product-title.component.vue?vue&type=script&lang=js&"
import style0 from "./product-title.component.vue?vue&type=style&index=0&id=47ee018c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee018c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ee018c')) {
      api.createRecord('47ee018c', component.options)
    } else {
      api.reload('47ee018c', component.options)
    }
    module.hot.accept("./product-title.component.vue?vue&type=template&id=47ee018c&scoped=true&", function () {
      api.rerender('47ee018c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/product-title.component.vue"
export default component.exports